import { isCustomizedType, reduce } from "et3-type-guards";
import { post } from "../axios-post";
import i18nServerResponse from "../../constants/i18n-server-response";
import { Ti18nKeys } from "../../constants/i18n";
import { DEFAULT_TIME } from "../../constants/input-entries-constants";
import { createDateFromSpecificDateString } from "../../helpers/et3-date-helper";
import getKhattabatStore from "../../stores/khattabat-stores";
import getKhattabat101CStore from "../../stores/khattabat-stores/101c-stores";

export const apiCallReactivateKhatabaClient = async ({
  userID
}: {
  userID: number;
}): Promise<{
  data: { ReactivationSentDate: Date };
  status: string;
  code: Ti18nKeys;
}> => {
  const oneOOneCId = getKhattabat101CStore(userID).oneOOneCId.get();
  const alkhattabaUUID = getKhattabatStore().alkhattabaUUID.get();
  const { status, data, et3Error } = await post<{
    ReactivationSentDate: Date;
  }>(`khattabat/reactivateKhatabaClient`, {
    oneOOneCId,
    userID,
    alkhattabaUUID
  });
  if (
    status === "OK" &&
    !isCustomizedType<{
      errorCode: string;
      et3Message: string;
    }>(
      {
        errorCode: "ERROR",
        et3Message: "ERROR"
      },
      data
    )
  ) {
    return {
      data,
      status: "OK",
      code: "SUCCESS"
    };
  } else if (status === "ERROR") {
    const errorNumber = reduce(() => et3Error.errorNumber, 0);
    return {
      data: {
        ReactivationSentDate: createDateFromSpecificDateString(DEFAULT_TIME)
      },
      status: "ERROR",
      code: i18nServerResponse.get(errorNumber)
    };
  } else {
    return {
      data: {
        ReactivationSentDate: createDateFromSpecificDateString(DEFAULT_TIME)
      },
      status: "ERROR",
      code: "ERROR"
    };
  }
};
